module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.73a93256.svg";